var PermissionService = /** @class */ (function () {
    function PermissionService(api) {
        var _this = this;
        this.getPermissionItems = function (app) { return _this.API.get("/permissions/items?app=".concat(app)); };
        this.getTargetPermissions = function (target, appId) {
            return _this.API.get("/permissions/targets/".concat(target, "?app=").concat(appId));
        };
        this.patchTargetPermissions = function (target, patches, appId) {
            return _this.API.patch("/permissions/targets/".concat(target), patches, false, { appId: appId });
        };
        this.getPermissionRoles = function (app) { return _this.API.get("/permissions/groups?app=".concat(app)); };
        this.getRolePermissions = function (app, group) {
            return _this.API.get("/permissions/groups/".concat(group, "?app=").concat(app));
        };
        this.patchRolePermissions = function (app, group, patches) {
            return _this.API.patch("/permissions/groups/".concat(group, "?app=").concat(app), patches);
        };
        this.API = api;
    }
    PermissionService.prototype.getGroups = function (appId) {
        return this.API.get("/groups/apps/".concat(appId));
    };
    PermissionService.prototype.getPermissions = function (url) {
        return this.API.get(url);
    };
    PermissionService.prototype.upsertPermissions = function (url, data, appId) {
        return this.API.put(url, data, false, { appId: appId });
    };
    PermissionService.prototype.getPermissionsByTargets = function (targets) {
        var url = "/permissions";
        if (!!localStorage.getItem('token')) {
            return this.API.post(url, {
                targets: targets,
            });
        }
    };
    PermissionService.prototype.getPermissionsByGroup = function (group) {
        return this.API.get("/permissions/group/".concat(group));
    };
    PermissionService.prototype.getPermissionsByUser = function (user) {
        return this.API.get("/permissions/user/".concat(user));
    };
    return PermissionService;
}());
export { PermissionService };
